<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>白名单管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="currentTab" @tab-click="onTabChange" style="margin-top: 20px">
      <el-tab-pane label="设备白名单" name="device"></el-tab-pane>
      <el-tab-pane label="IP白名单" name="ip"></el-tab-pane>
    </el-tabs>

    <el-table :data="listData" v-loading="loading" border stripe style="width: 100%" size="small">
      <el-table-column type="index" label="#" width="60" align="center" />
      <el-table-column prop="id" label="ID" width="100" align="center" />
      <el-table-column :prop="currentTab === 'device' ? 'oaid' : 'oaip'"
        :label="currentTab === 'device' ? 'OAID' : 'IP地址'" min-width="300" align="center" show-overflow-tooltip />
      <el-table-column prop="addtime" label="添加时间" width="200" align="center">
        <template slot-scope="scope">{{ scope.row.addtime | formatTs }}</template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号" width="150" align="center" />
      <el-table-column prop="reason" label="备注" min-width="200" align="center" show-overflow-tooltip />
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" style="color: #e34d59" @click="onDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 20px; text-align: right">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="onPageChange" />
    </div>
  </div>
</template>

<script>
import { whiteDevicePage, whiteDeviceDelete, whiteIpPage, whiteIpDelete } from '../../api/whitelistMG'

export default {
  data() {
    return {
      currentTab: 'device',
      listData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    onTabChange() {
      this.currentPage = 1
      this.loadData()
    },
    loadData() {
      this.loading = true
      var params = { pageNo: this.currentPage - 1, pageSize: this.pageSize }
      var api = this.currentTab === 'device' ? whiteDevicePage(params) : whiteIpPage(params)
      api.then(res => {
        this.loading = false
        if (res.success !== false) {
          this.listData = res.data.records || []
          this.total = res.data.total || 0
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('加载失败')
      })
    },
    onPageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    onDelete(row) {
      var label = this.currentTab === 'device' ? row.oaid : row.oaip
      this.$confirm('确定删除「' + label + '」吗？', '确认删除', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        var api = this.currentTab === 'device' ? whiteDeviceDelete({ id: row.id }) : whiteIpDelete({ id: row.id })
        return api
      }).then(() => {
        this.$message.success('删除成功')
        this.loadData()
      }).catch(() => {})
    }
  },
  filters: {
    formatTs(ts) {
      if (!ts) return '--'
      var d = new Date(ts)
      if (isNaN(d.getTime())) return ts
      var pad = function (n) { return String(n).padStart(2, '0') }
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) +
        ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/whitelist/index.vue